import Link from '@feature/Link'
import { LinkProps } from '@feature/Link/Link'
import { useAppSelector } from 'app/hooks'
import { getSelectTermById } from 'app/selectors'
import React, { PropsWithChildren } from 'react'
import { TermBase, TermIdentifier } from 'types'

export type TermLinkProps = PropsWithChildren<
  Omit<LinkProps, 'to'> & {
    term: TermBase | TermIdentifier
  }
>

export const TermLink = ({ term: { taxonomyId, id }, children, ...props }: TermLinkProps) => {
  const { uri, name } = useAppSelector(getSelectTermById(taxonomyId, id)) ?? {}

  children = children ?? name

  return !uri ? (
    <>{children}</>
  ) : (
    <Link to={uri} {...props}>
      {children}
    </Link>
  )
}

export default TermLink
